import FooterOtherSources from './FooterOtherSources'

export default FooterOtherSources